import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { ParticipantService } from '@participant/services/participant.service'

export const publicGuard: CanActivateFn = () => {
  const participantService = inject(ParticipantService)
  const router = inject(Router)

  const participant = participantService.participant

  if (!participant?.authenticated) {
    return true
  }

  router.navigate(['/'])
  return true
}
